import { render, staticRenderFns } from "./ViewRetailerConnectionForPublicRG.vue?vue&type=template&id=6f64ed06&scoped=true&"
import script from "./ViewRetailerConnectionForPublicRG.vue?vue&type=script&lang=ts&"
export * from "./ViewRetailerConnectionForPublicRG.vue?vue&type=script&lang=ts&"
import style0 from "./ViewRetailerConnectionForPublicRG.vue?vue&type=style&index=0&id=6f64ed06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f64ed06",
  null
  
)

export default component.exports